"use client"

import type React from "react"

import { useEffect, useState } from "react"
import { observer } from "mobx-react-lite"
import { useAppContext } from "../../../shared/functions/Context"
import ErrorBoundary from "../../../shared/components/error-boundary/ErrorBoundary"

import Modal from "../../../shared/components/Modal"
import MODAL_NAMES from "../../dialogs/ModalName"
import MyTrainingRequests from "./my-training/MyTrainingRequests"
import InternalTrainingRequests from "./internal-training/InternalTrainingRequests"
import ExternalTrainingRequests from "./external-training/ExternalTrainingRequests"
import TeamTrainingRequests from "./my-team-requests/my-training/TeamTrainingRequests"
import ViewTrainingRequest from "../../dialogs/personal-development/ViewTrainingRequest"
import CreateCatalogTrainings from "../../dialogs/personal-development/CreateCatalogTrainings"
import ApproveTrainingRequest from "../../dialogs/personal-development/ApproveTrainingRequest"
import RequestTrainingRequestModal from "../../dialogs/personal-development/RequestTrainingRequestModal"
import CompleteCoarseModal from "../../dialogs/personal-development/CompleteCoarseModal"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../dashboard/company-dashboard/ui/tabs"

const Trainings: React.FC = () => {
  const { store, api, ui } = useAppContext()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const loadAll = async () => {
      setLoading(true)
      try {
        await Promise.all([api.trainingRequest.getAll(), api.department.getAll()])
      } catch (error) {
        ui.snackbar.load({
          id: Date.now(),
          message: "Failed to load.",
          type: "danger",
        })
      }
      setLoading(false)
    }
    loadAll()
  }, [api, ui.snackbar])

  return (
    <div className="w-full space-y-6">
      <ErrorBoundary>
        <Tabs defaultValue="my-catalog" className="w-full">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="my-catalog">My Training Catalog</TabsTrigger>
            <TabsTrigger value="internal">Internal Training Catalog</TabsTrigger>
            <TabsTrigger value="external">External Training Catalog</TabsTrigger>
            <TabsTrigger value="team">Team Training Requests</TabsTrigger>
          </TabsList>

          <TabsContent value="my-catalog" className="mt-6">
            <MyTrainingRequests />
          </TabsContent>
          <TabsContent value="internal" className="mt-6">
            <InternalTrainingRequests />
          </TabsContent>
          <TabsContent value="external" className="mt-6">
            <ExternalTrainingRequests />
          </TabsContent>
          <TabsContent value="team" className="mt-6">
            <TeamTrainingRequests />
          </TabsContent>
        </Tabs>
      </ErrorBoundary>

      <ErrorBoundary>
        <Modal modalId={MODAL_NAMES.EXECUTION.PERSONAL_DEVELOPMENT_VIEW_TRAINING_MODAL}>
          <ViewTrainingRequest />
        </Modal>
        <Modal modalId={MODAL_NAMES.EXECUTION.PERSONAL_DEVELOPMENT_COMPLETE_TRAINING_MODAL}>
          <CompleteCoarseModal />
        </Modal>
        <Modal modalId={MODAL_NAMES.EXECUTION.PERSONAL_DEVELOPMENT_APPROVE_TRAINING_MODAL}>
          <ApproveTrainingRequest />
        </Modal>
        <Modal modalId={MODAL_NAMES.EXECUTION.PERSONAL_DEVELOPMENT_REQUEST_TRAINING_MODAL}>
          <RequestTrainingRequestModal />
        </Modal>
        <Modal modalId={MODAL_NAMES.EXECUTION.PERSONAL_DEVELOPMENT_CREATE_TRAINING_CATALOG_MODAL}>
          <CreateCatalogTrainings />
        </Modal>
      </ErrorBoundary>
    </div>
  )
}

export default observer(Trainings)
